import { urlApi } from '../../config'
import { getAccessToken } from '../../auth'

export default async function refundTransaction(transactionId, reason) {
  try {
    const token = await getAccessToken()
    const response = await fetch(
      `${urlApi}/admin/transactions/refund/${encodeURIComponent(transactionId)}`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          ...(typeof token === 'string' && { Authorization: `Bearer ${token}` })
        },
        body: JSON.stringify({ reason })
      }
    )
    const data = await response.json().catch(() => null)
    return { ok: response.ok, status: response.status, data }
  } catch (error) {
    console.error(error)
    return { ok: false, status: 0, data: null }
  }
}
